import { motion } from 'motion/react';
import { InputNumber, Button, Text } from '@clockout-dev/design-elements';
import { DeleteOutlined } from '@ant-design/icons';
import styles from '../../../styles/feeStructureForm.module.scss';

function VolumeTiersRow({
    onRemove,
    onUpdate,
    conflictIds,
    id,
    from,
    to,
    fee,
    commitOrder
}) {
    const hasConflict = conflictIds.has(id);
    const status = hasConflict ? 'error' : undefined;

    return (
        <motion.div
            key={id}
            layout
            transition={{ duration: 0.3, ease: 'easeOut' }}
            className={styles.ruleRow}
        >
            <Text as="span" size="s" className={styles.ruleLabel}>if the advance is greater than</Text>
            <InputNumber
                value={from}
                prefix="$"
                onChange={(value) => onUpdate(id, 'fromAmount', value)}
                onBlur={commitOrder}
                min={0}
                max={99999}
                step={1}
                precision={0}
                controls={false}
                status={status}
                className={`${styles.inlineNumberInput} ${styles.rangeField}`}
            />
            <Text as="span" size="s" className={styles.ruleLabel}>and less or equal to</Text>
            <InputNumber
                value={to}
                prefix="$"
                onChange={(value) => onUpdate(id, 'toAmount', value)}
                min={0}
                max={99999}
                step={1}
                precision={0}
                controls={false}
                status={status}
                className={`${styles.inlineNumberInput} ${styles.rangeField}`}
            />
            <Text as="span" size="s" className={styles.ruleLabel}>their advance fee is</Text>
            <InputNumber
                value={fee}
                prefix="$"
                onChange={(value) => onUpdate(id, 'fee', value)}
                min={0}
                max={999.99}
                step={0.01}
                precision={2}
                controls={false}
                className={`${styles.inlineNumberInput} ${styles.amountField}`}
            />
            <Button
                type="button"
                size="s"
                variant="text"
                className={styles.deleteButton}
                onClick={() => onRemove(id)}
            >
                <DeleteOutlined />
            </Button>
        </motion.div>
    );
}

export default VolumeTiersRow;
